<template>
  <v-dialog v-model="dialogModel" max-width="800" persistent>
    <v-card class="pa-4">
      <v-card-title>Add New Task</v-card-title>

      <v-card-text>
        <div class="d-flex flex-column ga-5">
          <span class="error-message" v-for="e in errors" :key="e">{{
            e
          }}</span>

          <!-- Form Fields -->
          <template v-for="field in formFields" :key="field.id">
            <div
              :class="[
                field.type === 'autocomplete' ? 'filed-autocomplete' : 'field',
                'd-flex flex-column ga-2',
              ]"
            >
              <label
                v-if="field.type !== 'switch'"
                :ref="field.ref"
                :for="field.id"
              >
                {{ field.label }}
                <span v-if="field.required" class="required">*</span>
              </label>

              <!-- Regular Input -->
              <input
                v-if="field.type === 'input'"
                :id="field.id"
                v-model="formData[field.id]"
                :type="field.inputType || 'text'"
                @input="updateValidationClass(field.ref, formData[field.id])"
              />

              <!-- Date Input -->
              <input
                v-else-if="field.type === 'datetime'"
                :id="field.id"
                v-model="formData[field.id]"
                type="text"
                :ref="field.id"
                @input="updateValidationClass(field.ref, formData[field.id])"
              />

              <v-file-upload
                v-if="field.type === 'file'"
                :id="field.id"
                v-model="formData[field.id]"
                clearable
                density="compact"
                variant="compact"
              ></v-file-upload>
              <!-- Autocomplete -->
              <v-autocomplete
                v-else-if="field.type === 'autocomplete'"
                v-model="formData[field.id]"
                :items="field.items"
                :item-value="field.itemValue"
                :item-title="field.itemTitle"
                hide-details
                chips
                @change="updateValidationClass(field.ref, formData[field.id])"
                :disabled="field.disabled"
                :ref="field.ref"
                :multiple="field.multiple"
              />

              <!-- Switch -->
              <div
                v-else-if="field.type === 'switch'"
                class="d-flex justify-end align-center ga-2 custom-switch"
              >
                <label :for="field.id">{{ field.label }}</label>
                <v-switch
                  color="green"
                  v-model="formData[field.id]"
                  hide-details
                  inset
                  :true-value="1"
                  :false-value="0"
                ></v-switch>
              </div>
            </div>
          </template>
        </div>
      </v-card-text>

      <v-card-actions class="sticky-footer-dialog">
        <v-spacer></v-spacer>
        <span class="cancel-btn cursor-pointer" @click="cancelDialog"
          >Cancel</span
        >
        <span class="choose-btn cursor-pointer" @click="saveTask">Save</span>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.css";
import { getFieldError } from "@/utils/formValdiation.js";
import apiClient from "@/core/buildRequest";
import { useContactsStore } from "@/store/crm/useContactsStore";
import { useAccountsStore } from "@/store/crm/useAccountsStore";
import { useProjectsStore } from "@/store/crm/useProjectsStore";
import { useDealsStore } from "@/store/crm/useDealsStore";
import { useTasksStore } from "@/store/crm/useTasksStore";
import { useGeneralStore } from "@/store/General";
import { VFileUpload } from "vuetify/labs/VFileUpload";
export default {
  components: {
    VFileUpload,
  },
  name: "TaskDialog",
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    contacts: {
      type: Array,
      default: () => [],
    },
    accounts: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      selectcontacts: "",
      selectaccounts: "",
      selectprojects: [],
      selectDeals: "",
      selectTasks: "",
      selectagents: "",
      formData: {
        name: "",
        description: "",
        start_date: "",
        due_date: "",
        add_start_date_to_calendar: 1,
        add_to_calendar: 1,
        assigness: [],
        account_id: null,
        status: null,
        project_id: null,
        attachment: null,
        notes: "",
      },
      errors: [],
      fieldErrors: {},
      flatpickrInstances: {},
      contacts_store: useContactsStore(),
      accounts_store: useAccountsStore(),
      projects_store: useProjectsStore(),
      deals_store: useDealsStore(),
      tasks_store: useTasksStore(),
      genral_store: useGeneralStore(),
    };
  },

  computed: {
    dialogModel: {
      get() {
        return this.dialog;
      },
      set(value) {
        this.$emit("update:dialog", value);
      },
    },

    formFields() {
      return [
        {
          id: "name",
          label: "Task Name",
          type: "input",
          required: true,
          ref: "taskNameInput",
          disabled: false,
          multiple: false,
        },
        {
          id: "description",
          label: "Description",
          type: "input",
          required: true,
          ref: "descriptionInput",
          disabled: false,
          multiple: false,
        },
        {
          id: "start_date",
          label: "Start Date",
          type: "datetime",
          required: true,
          ref: "startDateInput",
          disabled: false,
          multiple: false,
        },
        {
          id: "due_date",
          label: "Due Date",
          type: "datetime",
          required: true,
          ref: "dueDateInput",
          disabled: false,
          multiple: false,
        },
        {
          id: "add_to_calendar",
          label: "Add Due Date To Calendar",
          type: "switch",
          disabled: false,
          multiple: false,
        },
        {
          id: "member_id",
          label: "Assignees",
          type: "autocomplete",
          items: this.selectagents,
          multiple: true,
          required: true,
          ref: "assigneesInput",
          itemTitle: "name",
          itemValue: "id",
          disabled: false,

        },
        {
          id: "project_id",
          label: "Project",
          type: "autocomplete",
          items: Array.isArray(this.selectprojects) ? this.selectprojects : [],
          itemTitle: "project_number",
          itemValue: "id",
          required: true,
          ref: "projectInput",
          disabled: false,
          multiple: false,
        },
        {
          id: "account_id",
          label: "Accounts",
          type: "autocomplete",
          items: this.accountItems, // يعتمد على المشروع المختار
          itemTitle: "account_number",
          itemValue: "id",
          multiple: false,
          required: true,
          ref: "accountsInput",
          disabled: !!this.selectedProject?.account_id, // اقفله لو مرتبط

        },
        {
          id: "attachment",
          label: "Attachment",
          type: "file",
          required: false,
          ref: "attachmentInput",
        },
        // {
        //   id: "contact_id",
        //   label: "Contacts",
        //   type: "autocomplete",
        //   items: this.selectcontacts,
        //   itemTitle: "contact_number",
        //   itemValue: "id",
        //   multiple: true,
        //   required: true,
        //   ref: "contactsInput",
        // },

        {
          id: "status",
          label: "Status",
          type: "autocomplete",
          items: ["active", "completed", "pending", "on_hold", "closed"],
          required: true,
          ref: "statusInput",
          disabled: false,
          multiple: false,
        },

        // {
        //   id: "deal_id",
        //   label: "Deal",
        //   type: "autocomplete",
        //   items: this.selectDeals,
        //   itemTitle: "deal_number",
        //   itemValue: "id",
        //   required: true,
        //   ref: "dealInput",
        // },
        // {
        //   id: "cost",
        //   label: "Cost",
        //   type: "input",
        //   inputType: "number",
        //   required: true,
        //   ref: "costInput",
        // },
        // {
        //   id: "weight",
        //   label: "Weight",
        //   type: "input",
        //   inputType: "number",
        //   required: true,
        //   ref: "weightInput",
        // },
        // {
        //   id: "estimated_bonus",
        //   label: "Estimated Bonus",
        //   type: "input",
        //   inputType: "number",
        //   required: true,
        //   ref: "estimatedBonusInput",
        // },
        {
          id: "notes",
          label: "Notes",
          type: "input",
          inputType: "text",
          required: false,
          ref: "notesInput",
        },
      ];
    },
    all_contacts() {
      return this.contacts_store?.getContacts || [];
    },
    all_accounts() {
      return this.accounts_store?.getAccounts || [];
    },
    all_projects() {
      return this.projects_store?.getProjects || [];
    },
    all_deals() {
      return this.deals_store?.getDeals || [];
    },
    selectedProject() {
      const list = Array.isArray(this.selectprojects)
        ? this.selectprojects
        : [];
      return list.find((p) => p.id === this.formData.project_id) || null;
    },
    accountItems() {
      // لو المشروع المختار مرتبط بحساب، اعرض الحساب ده فقط
      if (this.selectedProject?.account_id) {
        return [
          {
            id: this.selectedProject.account_id,
            account_number: this.selectedProject.account_number,
            name: this.selectedProject.account_name,
          },
        ];
      }
      // وإلا، اعرض كل الحسابات العادية
      return Array.isArray(this.selectaccounts) ? this.selectaccounts : [];
    },
  },

  watch: {
    dialog(newVal) {
      if (newVal) {
        // this.getAllcontacts();
        this.getAllAccounts();
        this.getAllprojects();
        // this.getAllDeals();
        this.getAllTasks();
        this.getAllagents();
        this.$nextTick(() => {
          this.initializeFlatPickr();
        });
      } else {
        this.destroyFlatPickr();
      }
    },
    "formData.add_to_calendar"(newVal) {
      if (newVal) {
        this.formData.add_to_calendar = 1;
      } else {
        this.formData.add_to_calendar = 0;
      }
    },
    "formData.add_start_date_to_calendar"(newVal) {
      if (newVal) {
        this.formData.add_start_date_to_calendar = 1;
      } else {
        this.formData.add_start_date_to_calendar = 0;
      }
    },
    contacts: {
      handler(newVal) {
        this.formData.contact_id = newVal;
      },
      deep: true,
    },

    accounts: {
      handler(newVal) {
        this.formData.accounts = newVal;
      },
      deep: true,
    },

    "formData.project_id"(val) {
      const list = Array.isArray(this.selectprojects)
        ? this.selectprojects
        : [];
      const p = list.find((x) => x.id === val);
      if (p?.account_id) {
        this.formData.account_id = p.account_id; // تعبئة أوتوماتيك
        this.updateValidationClass("accountsInput", this.formData.account_id);
      } else {
        this.formData.account_id = null; // يسمح باختيار يدوي
      }
    },
  },

  beforeUnmount() {
    this.destroyFlatPickr();
  },

  methods: {
    // logSelectedObject(fieldKey, itemsList) {
    //   const value = this.formData[fieldKey];
    //   if (Array.isArray(value)) {
    //     // Multiple selection
    //     const selectedObjects = value
    //       .map((id) => itemsList.find((item) => item.id === id))
    //       .filter(Boolean);
    //     console.log(`${fieldKey} Selected Objects:`, selectedObjects);
    //   } else {
    //     // Single selection
    //     const selectedObject = itemsList.find((item) => item.id === value);
    //     console.log(`${fieldKey} Selected Object:`, selectedObject);
    //   }
    // },
    initializeFlatPickr() {
      this.destroyFlatPickr();
      const startDateEl = this.$refs.start_date?.[0];
      if (startDateEl) {
        this.flatpickrInstances.startDate = flatpickr(startDateEl, {
          enableTime: true,
          dateFormat: "Y-m-d H:i",
          time_24hr: true,
          onChange: (selectedDates) => {
            this.formData.start_date = selectedDates[0]
              ? selectedDates[0].toISOString().split("T")[0]
              : "";
            this.updateValidationClass(
              "startDateInput",
              this.formData.start_date
            );
          },
        });
      }

      const dueDateEl = this.$refs.due_date?.[0];
      if (dueDateEl) {
        this.flatpickrInstances.dueDate = flatpickr(dueDateEl, {
          enableTime: true,
          dateFormat: "Y-m-d H:i",
          time_24hr: true,
          onChange: (selectedDates) => {
            this.formData.due_date = selectedDates[0]
              ? selectedDates[0].toISOString().split("T")[0]
              : "";
            this.updateValidationClass("dueDateInput", this.formData.due_date);
          },
        });
      }
    },

    destroyFlatPickr() {
      Object.values(this.flatpickrInstances).forEach((instance) => {
        if (instance) {
          instance.destroy();
        }
      });
      this.flatpickrInstances = {};
    },

    validateForm() {
      this.errors = [];
      this.fieldErrors = {};
      let isValid = true;

      for (const field of this.formFields) {
        if (!field.required) continue;

        const value = this.formData[field.id];
        const error = getFieldError(field.label, value);

        if (error) {
          isValid = false;
          this.fieldErrors[field.id] = error;
          const el = this.$refs[field.ref]?.[0];
          if (el) {
            el.classList.add("error-validation");
          }
        }
      }

      return isValid;
    },

    updateValidationClass(ref, value) {
      const el = this.$refs[ref]?.[0];
      if (el) {
        el.classList[!value ? "add" : "remove"]("error-validation");
      }
    },

    resetForm() {
      Object.keys(this.formData).forEach((key) => {
        this.formData[key] = Array.isArray(this.formData[key]) ? [] : "";
      });
      this.formData.add_start_date_to_calendar = true;
      this.formData.add_to_calendar = true;
      this.errors = [];
      this.fieldErrors = {};
    },

    cancelDialog() {
      this.resetForm();
      this.$emit("update:dialog", false);
    },

    async saveTask() {
      if (!this.validateForm()) return;
      this.genral_store.ShowLoading();
      try {
        await apiClient.post("/leads-managment/tasks", this.formData);
        this.resetForm();
        this.$emit("update:dialog", false);
        this.tasks_store.getAllTasks();
        this.genral_store.showSnackbar("Task saved successfully", "#237276");
      } catch (error) {
        this.errors.push(error.response?.data?.msg || "An error occurred");
        console.error(error);
      } finally {
        this.genral_store.HideLoading();
      }
    },
    //get Allagents
    async getAllagents() {
      try {
        var response = await apiClient.get(`/leads-managment/all-agents`);
        const agentid = response.data.data;
        this.selectagents = Array.isArray(agentid)
          ? agentid.map((e) => ({
              id: e.id,
              name: e.first_name + " " + e.last_name,
            }))
          : [];
      } catch (err) {
        console.error("Error fetching deals:", err);
      }
    },
    //get Allcontacts
    // async getAllcontacts() {
    //   try {
    //     var response = await apiClient.get(`/leads-managment/list-contacts`);
    //     this.selectcontacts = response.data.data.data;
    //   } catch (err) {
    //     console.error("Error fetching deals:", err);
    //   }
    // },
    // get Accounts
    async getAllAccounts() {
      try {
        var response = await apiClient.get(`/leads-managment/accounts`);
        this.selectaccounts = response.data.data.data;
      } catch (err) {
        console.error("Error fetching deals:", err);
      }
    },
    //get projects
    async getAllprojects() {
      try {
        const { data } = await apiClient.get(`/leads-managment/projects`);
        const rows = data?.data?.data ?? [];
        this.selectprojects = rows.map((p) => ({
          id: p.id,
          project_number: p.project_number,
          // حقول الحساب من الـ object اللي انت بعتّه
          account_id: p.account?.id ?? p.account_id ?? null,
          account_number: p.account?.account_number ?? null,
          account_name: p.account?.name ?? null,
        }));
      } catch (err) {
        console.error("Error fetching projects:", err);
        this.selectprojects = [];
      }
    },
    // //get Deal
    // async getAllDeals() {
    //   try {
    //     var response = await apiClient.get(`/leads-managment/deals`);
    //     this.selectDeals = response.data.data.data;
    //   } catch (err) {
    //     console.error("Error fetching deals:", err);
    //   }
    // },
    //get tasks
    async getAllTasks() {
      try {
        var response = await apiClient.get(`/leads-managment/tasks`);
        this.selectTasks = response.data.data.data;
      } catch (err) {
        console.error("Error fetching deals:", err);
      }
    },
  },
  mounted() {
    if (this.dialog) {
      this.initializeFlatPickr();
    }
  },
};
</script>
